
import { TranslationKeys } from '@/types/translations';

const enTranslations: TranslationKeys = {
  // Navbar
  'nav.home': 'Home',
  'nav.properties': 'Properties',
  'nav.blog': 'Blog',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.login': 'Log in',

  // Home page - SEO optimized
  'home.hero.title': 'Find the best accommodations and lodging',
  'home.hero.highlight': 'in Manzanillo, Colima',
  'home.hero.subtitle': 'Quality accommodations, beautiful and affordable, only from super hosts in Manzanillo.',
  'home.hero.search_form_title': 'Book your stay',
  'home.hero.checkin': 'Checkin',
  'home.hero.checkout': 'Checkout',
  'home.hero.guests': 'Guests',
  'home.hero.bullet_one': 'Only super hosts',
  'home.hero.bullet_two': 'Quick booking',
  'home.hero.bullet_three': 'Flexible cancellation',
  'home.hero.average_rating': 'Average rating',
  'home.hero.reviews_count': '4.97/5 · 65 reviews',

  // Properties page
  'properties.title': 'Accommodations in Manzanillo',
  'properties.subtitle': 'Whether you come for vacation or work, with family, friends or as a couple. We have the ideal accommodation for you.',

  // Stats
  'stats.bookings': 'Bookings completed',
  'stats.happy_guests': 'Happy guests',
  'stats.average_score': 'Average score',
  'stats.support': 'Support',

  // Featured properties
  'featured.title': 'Featured accommodations in Manzanillo',
  'featured.subtitle': 'Stay at the best properties in Manzanillo with the best hosts. Quality accommodations, beautiful and affordable.',

  // How it works
  'how_it_works.title': 'How to book your accommodation',
  'how_it_works.subtitle': 'Book your ideal property in just 3 steps',
  'how_it_works.search.title': 'Search',
  'how_it_works.search.description': 'Explore available properties in Manzanillo.',
  'how_it_works.book.title': 'Book',
  'how_it_works.book.description': 'Submit your reservation request.',
  'how_it_works.enjoy.title': 'Enjoy',
  'how_it_works.enjoy.description': 'We\'ll contact you for payment.',

  // Reviews
  'reviews.title': 'Guest reviews in Manzanillo',
  'reviews.subtitle': 'We want to make you feel at home, and they confirm it.',
  'reviews.review_one_comment': 'The apartment was absolutely lovely and exceeded my expectations. It was clean, comfortable, and well-equipped with everything I needed. The decor was modern and stylish, and the location was perfect for exploring the city.',
  'reviews.review_one_location': 'Jalisco, México',
  'reviews.review_two_comment': 'The apartment is absolutely beautiful and spotless, no matter where you look. The area is very central, lovely, and has plenty of places to eat, have fun, and stroll around. We were enchanted with the apartment.',
  'reviews.review_two_location': 'Jalisco, México',
  'reviews.review_three_comment': 'The apartment is in a very nice complex. The grounds are spotless and well looked after. The pool was amazing. Ileana and co-host checked in to make sure all was good and we\'re very prompt when asked for anything.',
  'reviews.review_three_location': 'Campbell River, Canada',

  // FAQ
  'faq.title': 'Frequently asked questions about accommodations in Manzanillo',
  'faq.subtitle': 'Find answers to the most common questions about our properties and services.',
  'faq.question_one': 'What amenities does the condo have?',
  'faq.answer_one': 'It has a shallow outdoor pool at room temperature. You\'ll also find green areas, children\'s play areas, a palapa, and lounge chairs.',
  'faq.question_two': 'How far is the nearest beach?',
  'faq.answer_two': 'The nearest beach is just a 5-minute walk from the condo. It\'s a calm beach, perfect for families with crystal-clear waters.',
  'faq.question_three': 'Do the properties have parking?',
  'faq.answer_three': 'Yes, all our properties include private and secure parking for our guests at no additional cost.',
  'faq.question_four': 'What are the check-in and check-out times?',
  'faq.answer_four': 'Check-in is from 3:00 PM, and check-out is by 11:00 AM. We can be flexible with these times depending on availability.',
  'faq.question_five': 'Are the properties family-friendly?',
  'faq.answer_five': 'Absolutely. Our properties are ideal for families, offering spacious areas, safe spaces for children, and all the necessary amenities.',
  'faq.question_six': 'What floor are the properties located on?',
  'faq.answer_six': 'We have properties located on various floors of the building, from the ground floor up to the third floor, all with excellent views and easy access.',
  'faq.question_seven': 'Are pets allowed?',
  'faq.answer_seven': 'Pets are not allowed in all properties; in the vast majority, this is due to condo regulations.',

  // Footer
  'footer.description': 'Our home, your home.',
  'footer.links': 'Links',
  'footer.contact': 'Contact',
  'footer.estancia_corta': 'Estancia Corta',
  'footer.management': 'Property management',
  'footer.publish': 'Publish your property',
  'footer.rights': 'All rights reserved.',

  // Search form
  'search.guests': 'Guests',
  'search.checkin': 'Check-in',
  'search.checkout': 'Check-out',
  'search.button': 'Search',

  // About page
  'about.hero.title': 'Who we are?',
  'about.hero.description.first': 'We are a company that aims to offer our guests only the best accommodations in Manzanillo. We believe that good accommodation is the start of a great trip.',
  'about.hero.description.second': 'We only publish properties from Super hosts, this way we ensure we provide the best experience for our guests.',
  'about.stats.bookings': 'Bookings completed',
  'about.stats.guests': 'Happy guests',
  'about.stats.rating': 'Average score',
  'about.mission.title': 'Our Mission',
  'about.mission.description': 'Creating travel experiences that exceed guest expectations by offering them the best accommodations in Manzanillo.',
  'about.values.title': 'Our Values',
  'about.values.excellence.title': 'Excellence',
  'about.values.excellence.description': 'We are committed to offering the highest quality in every detail of our services and properties.',
  'about.values.hospitality.title': 'Hospitality',
  'about.values.hospitality.description': 'We treat each guest like family, providing personalized and warm service that makes the difference.',
  'about.values.sustainability.title': 'Sustainability',
  'about.values.sustainability.description': 'We respect and protect the natural environment around us, implementing sustainable practices in all our operations.',
  'about.property_owners.title': 'Do you have a property?',
  'about.property_owners.subtitle': 'Maximize your property\'s potential with our professional services',
  'about.property_owners.management.title': 'Full Management',
  'about.property_owners.management.description': 'We take care of everything: from cleaning and maintenance to guest service.',
  'about.property_owners.marketing.title': 'Professional Marketing',
  'about.property_owners.marketing.description': 'Professional photography, optimized descriptions and competitive pricing strategies.',
  'about.property_owners.support.title': '24/7 Support',
  'about.property_owners.support.description': 'Continuous attention to your guests and immediate resolution of any situation.',
  'about.property_owners.cta': 'Contact us for more information',
};

export default enTranslations;
